import { Accordion, Callout, Card, Checkbox, Col, Label, OutlineButton, PrimaryButton, Row, Tooltip, PopupDialogbox, SwitchToggle,EventHandler } from 'client/CommonComponents';
import Growth from './Growth';
import './Request.scss'
import Planned from './Planned';
import { CONSTANTS } from '../../../../utils/constants'
import Uploader from "../../../OrderManagement/Attachments/Uploader";
import deleteOrder from '../../../../assets/images/Delete New.svg';
import deleteItem from '../../../../assets/images/Delete 2 New.svg';
import plus from '../../../../assets/images/Plus New.svg'
import Reason from './Reason/Reason-Container';
import CompleteConfirmationPopup from 'client/CommonComponents/DialogBox/CompleteConfirmationPopup';
import CatalogItem from '../CatalogItem';
import DriverTitle from '../DriverTitle';
import DealerDetails from '../DealerDetails';
import { formatPrice } from "utils";
import permissions, { isAuthorized } from 'client/utils/Permissions';
import GetAttachmentView from 'client/CommonComponents/AttachmentView';


const ItemDetails = (props: any) => {

    const onClickResetReason = props.onClickResetReason;
    const onClickAddToCart = props.onClickAddToCart;
    const productionVehicleList = props.productionVehicleList;
    const nonStandardEquipmentList = props.nonStandardEquipmentList;
    const managementVehicleList = props.managementVehicleList;
    const reasonList = props.reasonList;
    const onClickDeleteReason = props.onClickDeleteReason;
    const onClickAddReason = props.onClickAddReason;
    const onClickDeleteRequest = props.onClickDeleteRequest;
    const showItemDetails = props.showItemDetails;
    const onChangeLinkAttachment = props.onChangeLinkAttachment;
    const onClicktLinkAttachment = props.onClicktLinkAttachment;
    const onCloseLinkAttachment = props.onCloseLinkAttachment;
    const getLinkedAttachmentsCount = props.getLinkedAttachmentsCount;
    let requestListTemp: any = [];
    const TOOLTIPCONTENT = CONSTANTS.ATTACHMENTS_TOOLTIP_CONTENT;
    const ACCEPT = CONSTANTS.ATTACHMENTS_ACCEPT;
    const Popupcontent = props.Popupcontent;
    const hideDialog = props.hideDialog;
    const popupOutlinebtnOnclick = props.popupOutlinebtnOnclick;
    const updateAttachments = props.updateAttachments;
    const attachmentsList = props.attachmentsList;
    const isAttachmentBtnClicked = props.isAttachmentBtnClicked;
    const onClickDriverLinkAttachment = props.onClickDriverLinkAttachment
    const isDriverAttachmentBtnClicked = props.isDriverAttachmentBtnClicked
    const onDriverCloseLinkAttachment = props.onDriverCloseLinkAttachment
    const collapse = props.collapse;
    const showCatalog = props?.showCatalog;
    const selectedRequisitionType = props?.selectedRequisitionType
    const managedEquipmentList = props?.managedEquipmentList;
    const isAttachmentRequired = props?.isAttachmentRequired;
    const addDriverDetails = props.addDriverDetails;
    const onClick = props?.onClick
    const handleClickRevert = props.handleClickRevert;
    const popupPrimarybtnOnclick = props.popupPrimarybtnOnclick;
    const isEditOrder = props.isEditOrder;
    const orderByIdValue = props.orderByIdValue;
    const selectedProductionAccordion = props.selectedProductionAccordion;
    const onChange = props.onChange;
    const selectedManagementAccordion = props.selectedManagementAccordion;
    const onChangeManagement = props.onChangeManagement;
    const selectedManagedAccordion = props.selectedManagedAccordion;
    const onChangeManaged = props.onChangeManaged;
    const selectedNonStandardAccordion = props.selectedNonStandardAccordion;
    const onChangeNonStandard = props.onChangeNonStandard;
    const updateIsMandAFlag = props.updateIsMandAFlag;
    const MandAcheck = props.MandAcheck;
    const cancelOrderReq = props.cancelOrderReq;
    const reasonCartList = props.reasonCartList;
    const onChangeQuotePrice = props.onChangeQuotePrice
    const onClickRequestType = props.onClickRequestType
    const onChangeQuoteAttached = props?.onChangeQuoteAttached
    const isApprovalOverrideFlag = props?.isApprovalOverrideFlag
    const updateIsApprovalOverrideFlag = props?.updateIsApprovalOverrideFlag
    const isCancelPopup = props?.isCancelPopup
    const isDealerSameForAllFlag = props?.isDealerSameForAllFlag;
    const updateIsDealerSameForAllFlag = props?.updateIsDealerSameForAllFlag;
    const setIsDealerChangesOccured = props?.setIsDealerChangesOccured;
    const checkManagedEquipCount = props?.checkManagedEquipCount

    let requestReasonCount = 0;
    let requestReasonCartCount = 0;

    const cancelOrdersubtext = (
        <>
            <p>Are you sure you want to cancel the Order</p>
            <p>
                <b>LEADR Order # : </b>{orderByIdValue?.orderId}
            </p>
        </>
    );

    productionVehicleList?.forEach((request: any, index: any) => {

        requestReasonCount = 0;
        requestReasonCartCount = 0;

        reasonCartList?.length && reasonCartList?.forEach((reason: any, index: any) => {
            if (request?.requestIndex === reason?.requestIndex) {
                requestReasonCartCount = requestReasonCartCount + 1;
            }
        });

        let reasonListTemp: any = [];
        const TooltipProps: any = {
            onRenderContent: () => {
                return <span>{request?.requestType} : {request?.vehicleType}{request?.showVehicleCapacity ? ' (' + (request?.vehicleCapacity) + ')' : null}, {request?.doorNos} doors</span>
            }
        }
        reasonList?.forEach((reason: any, index: any) => {
            if (request?.requestIndex === reason?.requestIndex) {
                requestReasonCount = requestReasonCount + 1;
                const item = {
                    headerText: (
                        <div className={`heading-container ${reason.isValid ? 'reason-is-added' : 'reason-is-not-added'}`}>
                            <div className='heading-container-subItem'>
                                <span><b className='reason-item'>ITEM # : {index + 1}</b><b>REASON:</b>{reason.reasonType != "Select Reason Type" ? reason.reasonType : null}</span>
                            </div>
                            <div className='right-heading'>
                                {reason.isValid ? '' : <span className='error-reason'>{reason.isValid ? '' : 'Reason is required'}</span>}
                                <EventHandler onEvent={(e: any) => onClicktLinkAttachment(e, index)} data-attribute="Request_Default_EventHandler">
                                    <span
                                        id={"link_attachment_" + index}
                                        className={(request?.requestType == CONSTANTS.PRODUCTION_VEHICLE && reason?.showQuotePrice && getLinkedAttachmentsCount(reason) <= 0) ? 'link-attachment errorLink me-0' : 'link-attachment me-0'}
                                    >
                                        <span className='fa fa-paperclip attachment-img'> </span> Link Attachment to Item ({getLinkedAttachmentsCount(reason)})
                                    </span>
                                </EventHandler>
                                {request?.requestType == CONSTANTS.PRODUCTION_VEHICLE && reason?.showQuotePrice && <span className='required me-0'>*</span>}
                                {isAttachmentBtnClicked?.[index] && (
                                    <Callout
                                        targetId={"link_attachment_" + index}
                                        toggleIsCalloutVisible={(e: any) => { onClicktLinkAttachment(e, index) }}
                                        calloutMaxHeight={300}
                                     data-attribute="Request_Default_Callout">
                                        <GetAttachmentView attachmentsList={attachmentsList} onCloseLinkAttachment={onCloseLinkAttachment} onChangeLinkAttachment={onChangeLinkAttachment} itemType={reason} />
                                    </Callout>
                                )}
                                <EventHandler onEvent={(e: any) => onClickDeleteReason(e, reason)} data-attribute="Request_Default_EventHandler_2">
                                    <img src={deleteItem} alt='delete' className='delete-img ms-4' />
                                </EventHandler>
                            </div>
                        </div>
                    ),
                    content: (<>
                        <Row>
                            {<Reason reason={reason} plannedRef={props.plannedRef} />}
                            {reason?.reasonType == CONSTANTS.REASON_PLANNED && <Planned onChangeQuotePrice={onChangeQuotePrice} requestType={request?.requestType} reason={reason} plannedRef={props.plannedRef} />}
                            {reason?.reasonType == CONSTANTS.REASON_UNPLANNED && <Planned onChangeQuotePrice={onChangeQuotePrice} requestType={request?.requestType} reason={reason} plannedRef={props.plannedRef} />}
                            {reason?.reasonType == CONSTANTS.REASON_GROWTH && <Growth onChangeQuotePrice={onChangeQuotePrice} requestType={request?.requestType} reason={reason} plannedRef={props.plannedRef} />}
                        </Row>
                        {

                            reason?.requestType === CONSTANTS.PRODUCTION_VEHICLE && reason?.showQuotePrice === true ? <DealerDetails reason={reason} plannedRef={props.plannedRef} setIsDealerChangesOccured={setIsDealerChangesOccured} /> : ''
                        }
                        <Row>
                            <Col xs={12} className='mb-1'>
                                <div className='pull-left reset-btn-reason'>
                                    <EventHandler onEvent={(e: any) => onClickResetReason(e, reason)} data-attribute="Request_Default_EventHandler_3">
                                        <a className='me-0' href='/'>Reset</a>
                                    </EventHandler>
                                </div>
                            </Col>
                        </Row>
                    </>),
                    uuid: `requestReason_Production${index}`,
                    dangerouslySetExpanded: selectedProductionAccordion.includes(`requestReason_Production${index}`),
                    key: reason?.reasonIndex
                };

                reasonListTemp.push(item);
            }

        })

        //sorting reasons array as last in first out order
        const sortedReasonsLIFO = reasonListTemp?.sort((a: any, b: any) => b?.key - a?.key)

        const item =
        {
            headerText: (
                <div className={`heading-container ${requestReasonCount == requestReasonCartCount && request?.isExistInCart ? "added-to-cart" : "not-added-to-cart"}`}>
                    <div className='left-heading'>
                        <EventHandler onEvent={(e: any) => { onClick(e); onClickRequestType(request) }} data-attribute="Request_Default_EventHandler_4">
                            <p className="accordion-heading create-order">
                                <Tooltip tooltipProps={TooltipProps} data-attribute="Request_Default_Tooltip">
                                    <p className='request-type'><b>{request?.requestType} : </b>{request?.vehicleType}{request?.showVehicleCapacity ? ' (' + (request?.vehicleCapacity) + ')' : null}, {request?.doorNos} doors</p>
                                </Tooltip>
                            </p>
                        </EventHandler>
                    </div>
                    <div className='right-heading margin-head'>
                        {request?.requestType == CONSTANTS.MANAGEMENT_VEHICLE ? <><span id={"driverlink_attachment_" + index} onClick={(e: any) => { onClickDriverLinkAttachment(e, index) }} className='link-attachment driver-link me-3'>
                            Add Driver (1)<span className={`ms-2 ${collapse ? 'up-image' : 'down-image'}`}></span>
                        </span>
                            {isDriverAttachmentBtnClicked?.[index] && (
                                <Callout
                                    targetId={"driverlink_attachment_" + index}
                                    toggleIsCalloutVisible={(e: any) => { onClickDriverLinkAttachment(e, index) }}
                                    calloutMaxHeight={300}
                                 data-attribute="Request_Default_Callout_2">
                                    <DriverTitle onDriverCloseLinkAttachment={onDriverCloseLinkAttachment} />
                                </Callout>
                            )}</> : null}
                        <EventHandler onEvent={(e: any) => onClickAddReason(e, request)} data-attribute="Request_Default_EventHandler_5">
                            <img src={plus} alt='Add Reason' className='me-2' />
                        </EventHandler>
                        <EventHandler onEvent={(e: any) => onClickDeleteRequest(e, request)} data-attribute="Request_Default_EventHandler_6">
                            <img src={deleteOrder} alt='Delete Order' className='me-2' />
                        </EventHandler>
                    </div>
                </div>
            ),
            content: (<>
                <Row>
                    <Col xs={12}>
                        <Accordion
                            Items={sortedReasonsLIFO}
                            preExpanded={[`requestReason_Production${index}`]}
                            onChange={onChange}
                            allowZeroExpanded
                            className={`sub-item-accordion ${request?.requestType}`}
                         data-attribute="Request_Default_Accordion" />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <div className='pull-right my-3 cart-margin'>
                            <PrimaryButton
                                btnRef={(element: any) => props.plannedRef.current[8] = element}
                                text={request?.isExistInCart ? "Update to Cart" : "Add to Cart"} onClick={() => onClickAddToCart(request)}
                                disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="Request_Default_Button">
                            </PrimaryButton>
                        </div>
                    </Col>
                </Row>

            </>),
            uuid: `requestItem_Production`,
            key: request?.requestIndex
        };

        requestListTemp.push(item);
    })

    nonStandardEquipmentList?.forEach((request: any, index: any) => {

        requestReasonCount = 0;
        requestReasonCartCount = 0;
        const nonStandardVinSerial = request?.vinSerial ? request.vinSerial : "-";

        reasonCartList?.length && reasonCartList?.forEach((reason: any, index: any) => {
            if (request?.requestIndex === reason?.requestIndex) {
                requestReasonCartCount = requestReasonCartCount + 1;
            }
        });

        let reasonListTemp: any = [];
        const TooltipProps: any = {
            onRenderContent: () => {
                return <span>{request?.requestType} : {'MAKE: ' + request?.make}{' | MODEL: ' + request?.model}{' | USED: ' + (request?.isUsed ? "Yes" : "No")}{' | VIN/SERIAL #: ' + nonStandardVinSerial}</span>
            }
        }
        reasonList?.forEach((reason: any, index: any) => {
            if (request?.requestIndex === reason?.requestIndex) {
                requestReasonCount = requestReasonCount + 1;

                const item = {
                    headerText: (
                        <div className={`heading-container ${reason.isValid ? 'reason-is-added' : 'reason-is-not-added'}`}>
                            <div className='heading-container-subItem'>
                                <span><b className='reason-item'>ITEM # : {index + 1}</b><b>REASON:</b>{reason?.reasonType != "Select Reason Type" ? reason?.reasonType : null}</span>
                            </div>
                            <div className='right-heading non-standard-equipment'>
                                {reason.isValid ? '' : <span className='error-reason'>{reason.isValid ? '' : 'Reason is required'}</span>}
                                <div className='switch-toggle-nse'>
                                    <SwitchToggle className='mb-0' checked={reason?.hasQuoteAttached} onChange={(e: any, item: any) => onChangeQuoteAttached(e, item, reason)}  data-attribute="Request_Default_SwitchToggle" />
                                    <span>Quote Attached</span>
                                </div>
                                <EventHandler onEvent={(e: any) => onClicktLinkAttachment(e, index)} data-attribute="Request_Default_EventHandler_7">
                                    <span
                                        id={"link_attachment_" + index}
                                        className={getLinkedAttachmentsCount(reason) > 0 ? 'link-attachment me-0' : 'link-attachment errorLink me-0'}
                                    >
                                        <span className='fa fa-paperclip attachment-img'> </span> Link Attachment to Item ({getLinkedAttachmentsCount(reason)})
                                    </span>
                                </EventHandler>
                                <span className='required me-4'>*</span>
                                {isAttachmentBtnClicked?.[index] && (
                                    <Callout
                                        targetId={"link_attachment_" + index}
                                        toggleIsCalloutVisible={(e: any) => { onClicktLinkAttachment(e, index) }}
                                        calloutMaxHeight={300}
                                     data-attribute="Request_Default_Callout_3">
                                        <GetAttachmentView attachmentsList={attachmentsList} onCloseLinkAttachment={onCloseLinkAttachment} onChangeLinkAttachment={onChangeLinkAttachment} itemType={reason} />
                                    </Callout>
                                )}
                                <EventHandler onEvent={(e: any) => onClickDeleteReason(e, reason)} data-attribute="Request_Default_EventHandler_8">
                                    <img src={deleteItem} alt='delete' className='delete-img' />
                                </EventHandler>
                            </div>
                        </div>
                    ),
                    content: (<>
                        <Row>
                            {<Reason reason={reason} plannedRef={props.plannedRef} />}
                            {reason?.reasonType == CONSTANTS.REASON_PLANNED && <Planned requestType={request?.requestType} reason={reason} plannedRef={props.plannedRef} />}
                            {reason?.reasonType == CONSTANTS.REASON_UNPLANNED && <Planned requestType={request?.requestType} reason={reason} plannedRef={props.plannedRef} />}
                            {reason?.reasonType == CONSTANTS.REASON_GROWTH && <Growth requestType={request?.requestType} reason={reason} plannedRef={props.plannedRef} />}
                        </Row>
                        <Row>
                            <Col xs={12} className='mb-1'>
                                <div className='pull-left reset-btn-reason'>
                                    <EventHandler onEvent={(e: any) => onClickResetReason(e, reason)} data-attribute="Request_Default_EventHandler_9">
                                        <a className='me-0' href='/'>Reset</a>
                                    </EventHandler>
                                </div>
                            </Col>
                        </Row>
                    </>),
                    uuid: `requestReason_NonStandard${index}`,
                    dangerouslySetExpanded: selectedNonStandardAccordion.includes(`requestReason_NonStandard${index}`),
                    key: reason?.reasonIndex
                };

                reasonListTemp.push(item);
            }

        })

        //sorting reasons array as last in first out order
        const sortedReasonsLIFO = reasonListTemp?.sort((a: any, b: any) => b?.key - a?.key)
        const item =
        {
            headerText: (
                <div className={`heading-container ${requestReasonCount == requestReasonCartCount && request?.isExistInCart ? "added-to-cart" : "not-added-to-cart"}`}>
                    <div className='left-heading'>
                        <EventHandler onEvent={(e: any) => { onClick(e); onClickRequestType(request) }} data-attribute="Request_Default_EventHandler_10">
                            <p className="accordion-heading create-order">
                                <Tooltip tooltipProps={TooltipProps} data-attribute="Request_Default_Tooltip_2">
                                    <span className='request-type'><b>{request?.requestType} : </b>{'MAKE: ' + request?.make}{' | MODEL: ' + request?.model}{' | USED: ' + (request?.isUsed ? "Yes" : "No")}{' | VIN/SERIAL #: ' + nonStandardVinSerial}</span>
                                </Tooltip>
                            </p>
                        </EventHandler>
                    </div>
                    <div className='right-heading margin-head'>
                        {request?.requestType !== CONSTANTS.NON_STANDARD_EQUIPMENT && <EventHandler onEvent={(e: any) => onClickAddReason(e, request)} data-attribute="Request_Default_EventHandler_11">
                            <img src={plus} alt='Add Reason' className='me-2' />
                        </EventHandler>}
                        <EventHandler onEvent={(e: any) => onClickDeleteRequest(e, request)} data-attribute="Request_Default_EventHandler_12">
                            <img src={deleteOrder} alt='Delete Order' className='me-2' />
                        </EventHandler>
                    </div>
                </div>
            ),
            content: (<>
                <Row>
                    <Col xs={12}>
                        <Accordion
                            Items={sortedReasonsLIFO}
                            preExpanded={[`requestReason_NonStandard${index}`]}
                            onChange={onChangeNonStandard}
                            allowZeroExpanded
                            className={`sub-item-accordion ${request?.requestType}`}
                         data-attribute="Request_Default_Accordion_2" />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <div className='pull-right my-3 cart-margin'>
                            <PrimaryButton
                                btnRef={(element: any) => props.plannedRef.current[8] = element}
                                text={request?.isExistInCart ? "Update to Cart" : "Add to Cart"} onClick={() => onClickAddToCart(request)} disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="Request_Default_Button_2"></PrimaryButton>
                        </div>
                    </Col>
                </Row>

            </>),
            uuid: `requestItem_NonStandard`,
            key: request?.requestIndex
        };

        requestListTemp.push(item);
    })

    if (managedEquipmentList?.length > 0) {
        managedEquipmentList?.forEach((request: any, index: any) => {

            requestReasonCount = 0;
            requestReasonCartCount = 0;

            reasonCartList?.length && reasonCartList?.forEach((reason: any, index: any) => {
                if (request?.requestIndex === reason?.requestIndex) {
                    requestReasonCartCount = requestReasonCartCount + 1;
                }
            });

            let reasonListTemp: any = [];
            let managedEquipmentPrice = request?.price?.toString().includes(',') ? parseFloat(request?.price?.replace(/,/g, "")) : request.price
            const TooltipProps: any = {
                onRenderContent: () => {
                    return <span>{request?.requestType} :  {request?.requestType == CONSTANTS.MANAGED_EQUIPMENT ? <p><>{request?.equipmentType}{'(' + request?.description + ', ' + parseFloat(managedEquipmentPrice).toFixed(2) + ')'}</></p> : null}</span>
                }
            }
            if (reasonList?.length > 0) {
                reasonList?.forEach((reason: any, index: any) => {

                    if (request?.requestIndex === reason?.requestIndex) {
                        requestReasonCount = requestReasonCount + 1;

                        const item = {
                            headerText: (
                                <div className={`heading-container ${reason.isValid ? 'reason-is-added' : 'reason-is-not-added'}`}>
                                    <div className='heading-container-subItem'>
                                        <span><b className='reason-item'>ITEM # : {index + 1}</b><b>REASON:</b>{reason.reasonType != "Select Reason Type" ? reason.reasonType : null}</span>
                                    </div>
                                    <div className='right-heading'>
                                        {reason.isValid ? '' : <span className='error-reason'>{reason.isValid ? '' : 'Reason is required'}</span>}
                                        <EventHandler onEvent={(e: any) => onClicktLinkAttachment(e, index)} data-attribute="Request_Default_EventHandler_13">
                                            <span
                                                id={"link_attachment_" + index}
                                                className={(request?.requestType == CONSTANTS.MANAGED_EQUIPMENT && reason?.showQuotePrice && getLinkedAttachmentsCount(reason) <= 0) ? 'link-attachment errorLink me-0' : (request?.requestType == CONSTANTS.MANAGED_EQUIPMENT && reason?.showQuotePrice || request?.requestType == CONSTANTS.MANAGEMENT_VEHICLE && reason?.showQuotePrice && getLinkedAttachmentsCount(reason) >= 0) ? 'link-attachment me-0' : 'link-attachment me-3'}
                                            >
                                                <span className='fa fa-paperclip attachment-img'> </span> Link Attachment to Item ({getLinkedAttachmentsCount(reason)})
                                            </span>
                                        </EventHandler>
                                        {request?.requestType == CONSTANTS.MANAGED_EQUIPMENT && reason?.showQuotePrice && <span className='required me-4'>*</span>}
                                        {isAttachmentBtnClicked?.[index] && (
                                            <Callout
                                                targetId={"link_attachment_" + index}
                                                toggleIsCalloutVisible={(e: any) => { onClicktLinkAttachment(e, index) }}
                                                calloutMaxHeight={300}
                                             data-attribute="Request_Default_Callout_4">
                                                <GetAttachmentView attachmentsList={attachmentsList} onCloseLinkAttachment={onCloseLinkAttachment} onChangeLinkAttachment={onChangeLinkAttachment} itemType={reason} />
                                            </Callout>
                                        )}
                                        <EventHandler onEvent={(e: any) => onClickDeleteReason(e, reason)} data-attribute="Request_Default_EventHandler_14">
                                            <img src={deleteItem} alt='delete' className='delete-img' />
                                        </EventHandler>
                                    </div>
                                </div>
                            ),
                            content: (<>
                                <Row>
                                    {<Reason reason={reason} plannedRef={props.plannedRef} />}
                                    {reason?.reasonType == CONSTANTS.REASON_PLANNED && <Planned requestType={request?.requestType} reason={reason} plannedRef={props.plannedRef} />}
                                    {reason?.reasonType == CONSTANTS.REASON_UNPLANNED && <Planned requestType={request?.requestType} reason={reason} plannedRef={props.plannedRef} />}
                                    {reason?.reasonType == CONSTANTS.REASON_GROWTH && <Growth requestType={request?.requestType} reason={reason} plannedRef={props.plannedRef} />}
                                </Row>
                                {request?.requestType == CONSTANTS.MANAGED_EQUIPMENT ? <DealerDetails reason={reason} plannedRef={props.plannedRef} setIsDealerChangesOccured={setIsDealerChangesOccured} /> : null}
                                <Row>
                                    <Col xs={12} className='mb-1'>
                                        <div className='pull-left reset-btn-reason'>
                                            <EventHandler onEvent={(e: any) => onClickResetReason(e, reason)} data-attribute="Request_Default_EventHandler_15">
                                                <a className='me-0' href='/'>Reset</a>
                                            </EventHandler>
                                        </div>
                                    </Col>
                                </Row>
                            </>),
                            uuid: `requestReason_Managed${index}`,
                            dangerouslySetExpanded: selectedManagedAccordion.includes(`requestReason_Managed${index}`),
                            key: reason?.reasonIndex
                        };
                        reasonListTemp.push(item);
                    }

                })
            }

            //sorting reasons array as last in first out order
            const sortedReasonsLIFO = reasonListTemp?.sort((a: any, b: any) => b?.key - a?.key)

            const item =
            {
                headerText: (
                    <div className={`heading-container ${requestReasonCount == requestReasonCartCount && request?.isExistInCart ? "added-to-cart" : "not-added-to-cart"}`}>
                        <div className='left-heading'>
                            <EventHandler onEvent={(e: any) => { onClick(e); onClickRequestType(request) }} data-attribute="Request_Default_EventHandler_16">
                                <p className="accordion-heading create-order">
                                    <Tooltip tooltipProps={TooltipProps} data-attribute="Request_Default_Tooltip_3">
                                        {request?.requestType == CONSTANTS.MANAGED_EQUIPMENT ? <p className='request-type'><><b>{request?.requestType} : </b>{request?.equipmentType}{'(' + request?.description + ', ' + `$${formatPrice(managedEquipmentPrice, 2)}` + ')'}</></p> : null}
                                    </Tooltip>
                                </p>
                            </EventHandler>
                        </div>
                        <div className='right-heading margin-head'>
                            <EventHandler onEvent={(e: any) => onClickAddReason(e, request)} data-attribute="Request_Default_EventHandler_17">
                                <img src={plus} alt='Add Reason' className='me-2' />
                            </EventHandler>
                            <EventHandler onEvent={(e: any) => onClickDeleteRequest(e, request)} data-attribute="Request_Default_EventHandler_18">
                                <img src={deleteOrder} alt='Delete Order' className='me-2' />
                            </EventHandler>
                        </div>
                    </div>
                ),
                content: (<>
                    <Row>
                        <Col xs={12}>
                            <Accordion
                                Items={sortedReasonsLIFO}
                                preExpanded={[`requestReason_Managed${index}`]}
                                onChange={onChangeManaged}
                                allowZeroExpanded
                                className="sub-item-accordion"
                             data-attribute="Request_Default_Accordion_3" />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <div className='pull-right my-3 cart-margin'>
                                <PrimaryButton
                                    btnRef={(element: any) => props.plannedRef.current[8] = element}
                                    text={request?.isExistInCart ? "Update to Cart" : "Add to Cart"} onClick={() => onClickAddToCart(request)}
                                    disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="Request_Default_Button_3">
                                </PrimaryButton>
                            </div>
                        </Col>
                    </Row>

                </>),
                uuid: `requestItem_Managed`,
                key: request?.requestIndex
            };

            requestListTemp.push(item);
        })
    }

    if (managementVehicleList?.length > 0) {
        managementVehicleList?.forEach((request: any, index: any) => {

            requestReasonCount = 0;
            requestReasonCartCount = 0;

            reasonCartList?.length && reasonCartList?.forEach((reason: any, index: any) => {
                if (request?.requestIndex === reason?.requestIndex) {
                    requestReasonCartCount = requestReasonCartCount + 1;
                }
            });

            let reasonListTemp: any = [];
            const TooltipProps: any = {
                onRenderContent: () => {
                    return <span>{request?.requestType} : {request?.driverTitle}</span>
                }
            }
            reasonList?.forEach((reason: any, index: any) => {
                if (request?.requestIndex === reason?.requestIndex) {
                    requestReasonCount = requestReasonCount + 1;
                    const item = {
                        headerText: (
                            <div className={`heading-container ${reason.isValid ? 'reason-is-added' : 'reason-is-not-added'}`}>
                                <div className='heading-container-subItem'>
                                    <span><b className='reason-item'>ITEM # : {index + 1}</b><b>REASON:</b>{reason.reasonType != "Select Reason Type" ? reason.reasonType : null}</span>
                                </div>
                                <div className='right-heading'>
                                    {reason.isValid ? '' : <span className='error-reason'>{reason.isValid ? '' : 'Reason is required'}</span>}
                                    <EventHandler onEvent={(e: any) => onClicktLinkAttachment(e, index)} data-attribute="Request_Default_EventHandler_19">
                                        <span
                                            id={"link_attachment_" + index}
                                            className={(request?.requestType == CONSTANTS.MANAGEMENT_VEHICLE && reason?.showQuotePrice && getLinkedAttachmentsCount(reason) <= 0) ? 'link-attachment errorLink me-0' : 'link-attachment me-0'}
                                        >
                                            <span className='fa fa-paperclip attachment-img'> </span> Link Attachment to Item ({getLinkedAttachmentsCount(reason)})
                                        </span>
                                    </EventHandler>
                                    {request?.requestType == CONSTANTS.MANAGEMENT_VEHICLE && reason?.showQuotePrice && <span className='required me-0'>*</span>}
                                    {isAttachmentBtnClicked?.[index] && (
                                        <Callout
                                            targetId={"link_attachment_" + index}
                                            toggleIsCalloutVisible={(e: any) => { onClicktLinkAttachment(e, index) }}
                                            calloutMaxHeight={300}
                                         data-attribute="Request_Default_Callout_5">
                                            <GetAttachmentView attachmentsList={attachmentsList} onCloseLinkAttachment={onCloseLinkAttachment} onChangeLinkAttachment={onChangeLinkAttachment} itemType={reason} />
                                        </Callout>
                                    )}
                                    <img src={deleteItem} alt='delete' className='delete-img ms-4' onClick={(e: any) => onClickDeleteReason(e, reason)} />
                                </div>
                            </div>
                        ),
                        content: (<>

                            <Row>
                                {<Reason reason={reason} plannedRef={props.plannedRef} />}
                                {reason?.reasonType == CONSTANTS.REASON_PLANNED && <Planned onChangeQuotePrice={onChangeQuotePrice} requestType={request?.requestType} reason={reason} plannedRef={props.plannedRef} />}
                                {reason?.reasonType == CONSTANTS.REASON_UNPLANNED && <Planned onChangeQuotePrice={onChangeQuotePrice} requestType={request?.requestType} reason={reason} plannedRef={props.plannedRef} />}
                                {reason?.reasonType == CONSTANTS.REASON_GROWTH && <Growth onChangeQuotePrice={onChangeQuotePrice} requestType={request?.requestType} reason={reason} plannedRef={props.plannedRef} />}
                            </Row>
                            {
                                reason?.requestType === CONSTANTS.MANAGEMENT_VEHICLE && reason?.showQuotePrice === true ? <DealerDetails reason={reason} plannedRef={props.plannedRef} setIsDealerChangesOccured={setIsDealerChangesOccured} /> : ''
                            }
                            <Row>
                                <Col xs={12} className='mb-1'>
                                    <div className='pull-left reset-btn-reason'>
                                        <EventHandler onEvent={(e: any) => onClickResetReason(e, reason)} data-attribute="Request_Default_EventHandler_20">
                                            <a className='me-0' href='/'>Reset</a>
                                        </EventHandler>
                                    </div>
                                </Col>
                            </Row>
                        </>),
                        uuid: `requestReason_Management${index}`,
                        dangerouslySetExpanded: selectedManagementAccordion.includes(`requestReason_Management${index}`),
                        key: reason?.reasonIndex
                    };

                    reasonListTemp.push(item);
                }

            })

            //sorting reasons array as last in first out order
            const sortedReasonsLIFO = reasonListTemp?.sort((a: any, b: any) => b?.key - a?.key)

            const item =
            {
                headerText: (
                    <div className={`heading-container ${requestReasonCount == requestReasonCartCount && request?.isExistInCart ? "added-to-cart" : "not-added-to-cart"} ${request?.requestType == CONSTANTS.MANAGEMENT_VEHICLE ? 'management-vehicle' : ''}`}>
                        <div className='left-heading'>
                            <EventHandler onEvent={(e: any) => { onClick(e); onClickRequestType(request) }} data-attribute="Request_Default_EventHandler_21"><p className="accordion-heading create-order">
                                <Tooltip tooltipProps={TooltipProps} data-attribute="Request_Default_Tooltip_4"><span className='request-type'><b>{request?.requestType} : </b>{request?.driverTitle}</span></Tooltip>
                            </p></EventHandler>
                        </div>
                        <div className='right-heading margin-head driver-title'>
                            {request?.vehicleDriverDetailsError?.length > 0 && <span className='error-reason'>{request?.vehicleDriverDetailsError}</span>}
                            {request?.requestType == CONSTANTS.MANAGEMENT_VEHICLE ? <><span id={"driverlink_attachment_" + index} onClick={(e: any) => { onClickDriverLinkAttachment(e, index) }} className='link-attachment driver-link me-0'>
                                Add Driver ({request?.vehicleDriverDetails?.length})<span className={`ms-2 ${collapse == true ? 'up-image' : 'down-image'}`}></span>
                            </span>
                                <span className='required me-3'>*</span>
                                {isDriverAttachmentBtnClicked?.[index] && (
                                    <Callout
                                        targetId={"driverlink_attachment_" + index}
                                        // Commented this function to resolve bug 196548 , it is hitting click function twice need to resolve later currently popup will not get close on clicking outside the popup
                                        toggleIsCalloutVisible={(e: any) => { onClickDriverLinkAttachment(e, index) }}
                                        calloutMaxHeight={300}
                                     data-attribute="Request_Default_Callout_6">
                                        <DriverTitle onDriverCloseLinkAttachment={onDriverCloseLinkAttachment} request={request} addDriverDetails={addDriverDetails} />
                                    </Callout>
                                )}</> : null}
                            <img src={plus} alt='Add Reason' className='me-2' onClick={(e: any) => onClickAddReason(e, request)} />
                            <EventHandler onEvent={(e: any) => onClickDeleteRequest(e, request)} data-attribute="Request_Default_EventHandler_22">
                                <img src={deleteOrder} alt='Delete Order' className='me-2' />
                            </EventHandler>
                        </div>
                    </div>
                ),
                content: (<>
                    <Row>
                        <Col xs={12}>
                            <Accordion
                                Items={sortedReasonsLIFO}
                                preExpanded={[`requestReason_Management${index}`]}
                                onChange={onChangeManagement}
                                className={`sub-item-accordion ${request?.requestType}`}
                             data-attribute="Request_Default_Accordion_4" />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <div className='pull-right my-3 cart-margin'>
                                <PrimaryButton
                                    btnRef={(element: any) => props.plannedRef.current[8] = element}
                                    text={request?.isExistInCart ? "Update to Cart" : "Add to Cart"} onClick={() => onClickAddToCart(request)} data-attribute="Request_Default_Button_4"></PrimaryButton>
                            </div>
                        </Col>
                    </Row>

                </>),
                uuid: `requestItem_Management`,
                key: request?.requestIndex
            };

            requestListTemp.push(item);
        })
    }

    //sorting request array as last in first out order
    const sortedRequestLIFO = requestListTemp?.sort((a: any, b: any) => b?.key - a?.key)

    return (
        <div>
            {selectedRequisitionType?.orderRequestType == CONSTANTS.MANAGED_EQUIPMENT && showCatalog && <CatalogItem setItemDetailComponent={props.setItemDetailComponent} />}

            <div className='item-details-requisition mt-3 mb-lg-0 mb-sm-3' ref={props.requestListTemp}>
                {requestListTemp?.length != 0 && showItemDetails &&
                    <Card data-attribute="Request_Default_Card">
                        <div className="border-bottom">
                            <div className='header'>
                                <div className="left-content requested-item">
                                    <div>
                                        <p className='headingText'>REQUESTED ITEM</p>
                                        <p className='subText request-ui'>Provide item details</p>
                                    </div>
                                </div>
                            </div>

        <div className="header">
            <div className='attachment-container'>
                <Label className='me-sm-2 mb-1 capital-lease' data-attribute="Request_Default_Label"><b>Capital/Lease Expenditures</b></Label>
                <div className='checkbox-container'>
                    {checkManagedEquipCount() >= 2 ? (
                        <div>
                            <div className="MA-checkbox me-sm-3">
                                <Label className="me-2" data-attribute="Request_Default_Label_2">Same Dealer For All Items</Label>
                                <Checkbox
                                    defaultChecked={isDealerSameForAllFlag}
                                    className="mb-0"
                                    onChange={updateIsDealerSameForAllFlag}
                                 data-attribute="Request_Default_Checkbox"></Checkbox>
                            </div>
                        </div>
                    )
                        : null}
                    {(!isEditOrder && isAuthorized(permissions.SetPreAuthorized)) &&
                        <div className='MA-checkbox approval-override me-sm-3'>
                            <Label className='me-2' data-attribute="Request_Default_Label_3">Approval Override(Pre-Authorized)</Label>
                            <Checkbox checked={isApprovalOverrideFlag} className='mb-0' onChange={updateIsApprovalOverrideFlag} data-attribute="Request_Default_Checkbox_2"></Checkbox>
                        </div>
                    }
                    <div className='MA-checkbox'>
                        <Label className='me-2' data-attribute="Request_Default_Label_4">M & A</Label>
                        <Checkbox defaultChecked={MandAcheck} className='mb-0' onChange={updateIsMandAFlag} data-attribute="Request_Default_Checkbox_3"></Checkbox>
                    </div>
                </div>
                {checkManagedEquipCount() >= 2 && isDealerSameForAllFlag && <p className='validMessage mt-0'>All items on this request will have the same dealer information</p>}
            </div>
             <div className='attachment-container'>
                <div>
                  <Uploader
                    updateAttachments={updateAttachments}
                    accept={ACCEPT}
                    link={true}
                    isAttachmentsRequired={nonStandardEquipmentList?.length > 0 || isAttachmentRequired}
                    tooltipConent={TOOLTIPCONTENT}
                    reasonAttachment={reasonList}
                    disabled={!isAuthorized(permissions.RequisitionsCreateUpdate)} />
                </div>
              </div>
        </div>
      </div>
       
        
        <Accordion
          Items={sortedRequestLIFO}
          preExpanded={['requestItem_Production','requestItem_Managed','requestItem_NonStandard', 'requestItem_Management']}
          className= {`item-detail-accordion`}
           data-attribute="Request_Default_Accordion_5" />
        <div className='cancel-edit-btn'>
          {
            (isEditOrder || (orderByIdValue?.orderStatus?.includes('Pending Approval'))) && <PrimaryButton className='ml-2' text='Revert Changes' onClick={handleClickRevert} disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)}  data-attribute="Request_Default_Button_5" />
          }
          {
            (isEditOrder || (orderByIdValue?.orderStatus?.includes('Pending Approval'))) && <OutlineButton text='Cancel Request' onClick={() => cancelOrderReq(cancelOrdersubtext)} disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="Request_Default_Button_6" />
          }
        </div>
      </Card>
    }
    {(Popupcontent.isDialogVisible && !isCancelPopup) ?
      <CompleteConfirmationPopup
        hideDialog={!Popupcontent.isDialogVisible}
        onDismiss={props.hideDialog}
        Popupcontent={props.Popupcontent}
        popupOutlinebtnOnclick={() => props.popupOutlinebtnOnclick("Home")}
        popupPrimarybtnOnclick={() => popupPrimarybtnOnclick("Home")}
      /> : ""
    }
    {(Popupcontent.isDialogVisible && isCancelPopup) &&
      <PopupDialogbox
        hideDialog={!Popupcontent.isDialogVisible}
        onDismiss={hideDialog}
        Popupcontent={Popupcontent}
        popupOutlinebtnOnclick={popupOutlinebtnOnclick}
        popupPrimarybtnOnclick={(
        item: any,
        actionby: string,
        value: any
        ) => {
          popupPrimarybtnOnclick(
            item,
            actionby,
            value);
          }}
       data-attribute="Request_Default_PopupDilalogBox" />
    }
      </div>
    </div>)
}

export default ItemDetails;
